<!-- eslint-disable vue/no-v-html -->
<template>
  <ul v-if="dataSearch" class="search-list">
    <div v-if="dataSearch.code === 500" class="no-results-container">
      <div class="icon-wrapper">
        <div class="icon-light" />
      </div>
      <div class="no-results-text">{{ $t('page_429') }}</div>
    </div>
    <!-- NO FAVS -->
    <div v-else-if="!hasQueryValue && type === 'fav-list' && dataSearch.count == 0" class="no-favs-yet">
      <div class="icon-wrapper">
        <div class="icon-light" />
      </div>
      <div class="no-results-text">{{ $t('no_favs') }}</div>
      <div class="no-results-tip">{{ $t('no_favs_ex') }}</div>
    </div>
    <div v-else-if="dataSearch.count == 0" class="no-results-container">
      <div class="icon-wrapper">
        <div class="icon-light" />
      </div>
      <!-- NO RESULTS -->
      <div v-if="dataSearch.code !== 400" class="no-results-text">{{ $t('no_results_search') }}</div>
      <div v-if="dataSearch.code !== 400" class="no-results-tip">{{ $t('no_results_tip') }}</div>
      <!-- CODE 400 -->
      <div v-else class="no-results-text">{{ $t('error_server_response') }}</div>
    </div>
    <!-- LIST -->
    <li 
      v-for="item in searchItems"
      v-else
      :key="item.id"
      class="search-item"
    >
      <SearchCard :data-card="item" :type="type" @rereload="reloadData" />
    </li>
  </ul>
</template>

<script>
import SearchCard from './SearchCard.vue'

/**
 * Filters, information and list of search card results
 * @example [none]
 */
export default {
  components: {
    SearchCard,
  },
  props: {
    /**
     * Object with search axios result
     */
    dataSearch: {
      type: Object,
    },
    type: {
      type: String,
      default: 'normal',
    },
  },
  computed: {
    searchItems() {
      return this.dataSearch.data
    },
    hasQueryValue() {
      return this.$route.query && Object.keys(this.$route.query).length > 0 ? true : false
    }
  },
  methods: {
    reloadData() {
      this.$emit('reload')
    },
  },
}
</script>

<style lang="stylus" scoped>
.search-list
  flex: 1 1 0%

.no-results-container
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  padding: vw(20px)
  height: 100%

  .mobile &
    padding: 0

.icon-wrapper
  display: flex
  justify-content: center
  align-items: center
  margin-bottom: vw(30px)
  width: vw(80px)
  height: vw(80px)
  border-radius: 50%
  background-color: #fff

  .icon-light
    m-icon("light", 40)

.no-results-text
  m-font-size(21, 24)
  text-align: center
  font-weight: 600

  .mobile &
    m-font-size(16, 20)

.no-results-tip
  m-font-size(16, 22)

.search-item
  list-style-type: none
  
  &:not(:last-child)
    margin-bottom: vw(15px)
    
.no-favs-yet
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
</style>
